setTimeout(function () {
  var fh = $("[data-product-form]").outerHeight();
  $(".innerdiv").css("height", fh);
}, 6000);
$(window).scroll(function () {
  if ($(this).scrollTop() > 150) {
    if($(".mobile_sticky").hasClass('Open_Crown_Product')){
      $(".mobile_sticky").removeClass("newClass");
    } else{
      $(".mobile_sticky").addClass("newClass");
    }
  } else {
    $(".mobile_sticky").removeClass("newClass");
  }

  const TabLabel = document.querySelector(".fast-simon-upsell-1704384824013");
  if (TabLabel) {
    var DescriptionTOP = $(".fast-simon-upsell-1704384824013").offset().top;
    if ($(this).scrollTop() > DescriptionTOP) {
      if($(".mobile_sticky").hasClass('Open_Crown_Product')){
        $("[data-product-form]").removeClass("newFormClass");
      } else{
        $("[data-product-form]").addClass("newFormClass");
      }
    } else {
      $("[data-product-form]").removeClass("newFormClass");
    }
  }
});
const rating_button = document.querySelector(".product__rating_main");
if (rating_button) {
  rating_button.addEventListener("click", () => {
    document
      .getElementById("tab-label-down")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  });
}

  const mediaQuery = window.matchMedia("(max-width: 719px)");
  if (mediaQuery.matches) {
    const mobile_rating_buttons = document.querySelectorAll(
      ".mobile-description-tab .tab-label"
    );
    mobile_rating_buttons.forEach((tablabel) => {
      tablabel.addEventListener("click", (event) => {
        event.preventDefault();
        tablabel.classList.toggle("tablabel-open");
      });
    });

    document.addEventListener("DOMContentLoaded", function () {
      var tab2Elements = document.getElementsByClassName("tab-radio");

      for (var i = 0; i < tab2Elements.length; i++) {
        var currentElement = tab2Elements[i];

        if (currentElement.checked) {
          var nextElement = currentElement.nextElementSibling;

          if (nextElement) {
            nextElement.classList.add("tablabel-open");
          }
        }
      }
    });
  }


const dataQuantityPlus = document.querySelectorAll('.cartitems [data-quantity-plus]');
const dataQuantityMinus = document.querySelectorAll('.cartitems [data-quantity-minus]');

if(dataQuantityPlus){
  dataQuantityPlus.forEach(function(QuantityPlus) {
    QuantityPlus.addEventListener('click', function() {
      const QuantityValue = QuantityPlus.dataset.qvalue;
      const QuantityVariantID = QuantityPlus.dataset.cartitemid;
      const IntQuantityValue = parseInt(QuantityValue);
      console.log(QuantityVariantID);
      console.log("Plus Click");
      
      let updates = {
        'id': QuantityVariantID,
        'quantity': IntQuantityValue+1
      };

      console.log(updates)
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  });
}  

if(dataQuantityMinus){
  dataQuantityMinus.forEach(function(QuantityMinus) {
    QuantityMinus.addEventListener('click', function() {
      const QuantityValue = QuantityMinus.dataset.qvalue;
      const QuantityVariantID = QuantityMinus.dataset.cartitemid;
      const IntQuantityValue = parseInt(QuantityValue);
      console.log(QuantityVariantID);
      console.log("Minus Click");
      
      let updates = {
        'id': QuantityVariantID,
        'quantity': IntQuantityValue-1
      };
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

      
    });
  });
}

(function ($) {
  
$('.gallery-navigation--scroller').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  variableWidth: true,
  slidesToShow: 1,
  slidesToScroll: 5,
  swipe: true
});






const button = document.querySelector('.scrollToTopBtn');

const displayButton = () => {
  window.addEventListener('scroll', () => {
  
    if (window.scrollY > 400) {
      button.style.display = "block";
    } else {
      button.style.display = "none";
    }
  });
};

const scrollToTop = () => {
  button.addEventListener("click", () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }); 
    console.log(event);
  });
};

displayButton();
scrollToTop();





  
})(jQuery);

// CUSTOM ATTRIBUTE
let isUpdatingMC4wfQ = false;

async function updateMC4wfQ() {
  if (isUpdatingMC4wfQ) return;
  isUpdatingMC4wfQ = true;

  try {
    // 1. Fetch profit JSON
    const res = await fetch('/pages/MC4wfQ');
    if (!res.ok) return;
    const data = await res.json();

    // 2. Update cart attribute
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          MC4wfQ: data.MC4wfQ.toFixed(2)
        }
      })
    });

  } catch (err) {
    console.error('Error:', err);
  } finally {
    isUpdatingMC4wfQ = false;
  }
}

(function() {
  const origFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = args[0];
    const res = await origFetch(...args);

    if (
      !isUpdatingMC4wfQ &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {
      setTimeout(updateMC4wfQ, 200);
    }

    return res;
  };
})();

// Datalayer event on view of the step on team-roper-bundle-builder page
{
  (function() {
    let lastStepViewed = null;
    let observerInitialized = false;

    function getActiveStep() {
      const activeTab = document.querySelector('.rebuy-bundle-builder__step-tab.active');
      if (!activeTab) return null;

      const match = activeTab.className.match(/step-tab-(\d+)/);
      if (match) {
        return parseInt(match[1]) + 1;
      }
      return null;
    }

    function sendStepViewedEvent(stepNumber) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'step_viewed',
        step_number: String(stepNumber)
      });
    }

    function initObserver() {
      const container = document.querySelector('.rebuy-bundle-builder__step-tabs-wrapper');
      if (!container || observerInitialized) return;

      observerInitialized = true;

      const observer = new MutationObserver(() => {
        const currentStep = getActiveStep();
        if (currentStep && currentStep !== lastStepViewed) {
          lastStepViewed = currentStep;
          sendStepViewedEvent(currentStep);
        }
      });

      observer.observe(container, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });

      const initialStep = getActiveStep();
      if (initialStep) {
        lastStepViewed = initialStep;
        sendStepViewedEvent(initialStep);
      }
    }

    const interval = setInterval(() => {
      const container = document.querySelector('.rebuy-bundle-builder__step-tabs-wrapper');
      if (container) {
        clearInterval(interval);
        initObserver();
      }
    }, 500);

    setTimeout(() => clearInterval(interval), 10000);
  })();
}

// Datalayer event on click on the add to cart button on team-roper-bundle-builder page
{
  (function () {
    const priceIndexByProductId = new Map();
    const priceIndexByCard = new WeakMap();

    function indexVisibleCards() {
      document
        .querySelectorAll('.rebuy-bundle-builder__product, .rebuy-product')
        .forEach((card) => {
          if (!name && !price) return;

          priceIndexByCard.set(card, { item_name: name, item_price: price });

          const cls = card.className;
          const m = String(cls).match(/product-id-(\d+)/);
          if (m) priceIndexByProductId.set(m[1], { item_name: name, item_price: price });
        });
    }

    indexVisibleCards();
    const indexInterval = setInterval(indexVisibleCards, 800);

    function getStepNumber() {
      const active =
        document.querySelector('[class*="rebuy-bundle-builder__step-container-"].rebuy-bundle-builder__step-container--active') ||
        document.querySelector('[class*="rebuy-bundle-builder__step-container-"].active');
      if (!active) return '';
      const m = active.className.match(/step-container-(\d+)/);
      return m ? String(parseInt(m[1], 10) + 1) : null;
    }

    function onAddClickCapture(e) {
      const btn = e.target.closest('button.rebuy-button');
      if (!btn) return;
      let priceContainer = btn.closest('.rebuy-bundle-builder__product-quantity')?.closest(".rebuy-product-actions")?.closest(".rebuy-bundle-builder__step-product");

      let item_price = priceContainer?.querySelectorAll(".rebuy-money span")[1].textContent.trim().replace(/\$/g, "");

      if (btn.closest('.rebuy-bundle-builder__summary, .rebuy-bundle-builder__footer')) return;

      const card =
        btn.closest('.rebuy-bundle-builder__product, .rebuy-product');

      let item_name = null;

      if (card) {
        const cached = priceIndexByCard.get(card);
        if (cached) {
          item_name = cached.item_name || null;
        } else {
          item_name = extractName(card);
        }

      }

      if (!item_name) {
        const al = btn.getAttribute('aria-label') || null;
        const n = al?.match(/Add (?:the )?product,\s*(.*?)\s*(?:to Cart|$)/i);
        if (n) item_name = n[1].trim();
      }

      const step_number = getStepNumber();

      window.dataLayer.push({
        event: 'step_add_to_cart',
        step_number,
        item_name,
        item_price
      });
    }

    document.addEventListener('click', onAddClickCapture, true);

    setTimeout(() => clearInterval(indexInterval), 120000);
  })();
}

// Datalayer event on the click  of bulk add to cart button on team-roper-bundle-builder page
{
  (function () {
    function getStepsCompleted() {
      const completed = document.querySelectorAll(
        '.rebuy-bundle-builder__step-container.active, .rebuy-bundle-builder__step-container--active, .rebuy-bundle-builder__step-container.completed'
      );
      return completed.length || null;
    }

    function getItemsAdded() {
      let addedProducts = document.querySelectorAll(".rebuy-bundle-builder__product-holder-data");
      return addedProducts.length || null;
    }

    function getCartTotal() {
      const btn = document.querySelector(
        '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
      );
      if (btn) {
        const text = btn.textContent || null;
        const match = text.match(/(\d+(?:\.\d{1,2})?)/);
        if (match) return match[1];
      }

      const totalEl = document.querySelector(
        '.rebuy-bundle-builder__summary, .rebuy-bundle-builder__group-container-total, [class*="bundle-total"]'
      );
      if (totalEl) {
        const clean = totalEl.textContent.replace(/[^0-9.]/g, null);
        if (clean) return clean;
      }

      return null;
    }

    function handleBulkAddClick(e) {
      const btn = e.target.closest(
        '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
      );
      if (!btn) return;

      const steps_completed = getStepsCompleted();
      const items_added = getItemsAdded();
      const cart_total = getCartTotal();

      window.dataLayer.push({
        event: 'bulk_add_to_cart',
        steps_completed: String(steps_completed),
        items_added: String(items_added),
        cart_total: parseFloat(cart_total)
      });
    }

    const interval = setInterval(() => {
      const btn = document.querySelector(
        '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
      );
      if (btn) {
        clearInterval(interval);
        document.body.addEventListener('click', handleBulkAddClick, true);
      }
    }, 500);

    setTimeout(() => clearInterval(interval), 10000);
  })();
}